import { useEffect } from 'react';
import './App.css';
import { ModalAlertProvider } from './contexts/ModalAlertContext';
import ModalAlert from './components/ModalAlert';
import TechCallView from './views/TechCallView';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router';
import CustomerCallView from './views/CustomerCallView';
import CustomerThanksView from './views/CustomerThanksView';

import { PleaseWait } from './components/PleaseWait';
import { TechLogin } from './views/TechLogin';
import AuthStore from './stores/AuthStore';
import AgoraRTC from 'agora-rtc-sdk-ng';
import { observer } from 'mobx-react';
import CustomerLogin from './views/CustomerLogin';
import TextModalAlert from './components/TextModalAlert';
import { RateOurServiceAlert } from './components/RateOurServiceAlert';
import CustomerReviewView from './views/CustomerReviewView';
import ImageModal from './components/ImageModal';
import ScreenShotView from './components/ScreenShotView';
import { SelffixLoadingProvider } from './contexts/SelffixLoadingContext';
import { SelffixLoading } from './components/SelffixLoading';
import SessionInformationView from './views/SessionInformationView';
import SessionLogsView from './views/SessionLogsView';

// ProtectedRoute component for routes that require authentication
const ProtectedRoute = observer(({ children, redirectTo = '/tech/login' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!AuthStore.isAuthenticated) {
      navigate(redirectTo);
    }
  }, [AuthStore.isAuthenticated, navigate, redirectTo]);

  if (!AuthStore.isAuthenticated) {
    return null;
  }

  return children;
});

const TechRoutes = observer(() => {
  const navigate = useNavigate();

  AgoraRTC.setLogLevel(4);

  useEffect(() => {
    // Only redirect if user is authenticated and trying to access login page
    if (AuthStore.isAuthenticated && window.location.pathname === '/tech/login') {
      navigate('/tech/dashboard');
    }
  }, [AuthStore.isAuthenticated, navigate]);

  return (
    <Routes>
      <Route path="/tech/login" element={<TechLogin />} />
      <Route
        path="/tech/dashboard"
        element={
          <ProtectedRoute>
            <SessionLogsView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/live/:slug"
        element={
          <ProtectedRoute>
            <TechCallView />
          </ProtectedRoute>
        }
      />
      <Route path="/tech/session/:slug" element={<ProtectedRoute><SessionInformationView /></ProtectedRoute>} />
    </Routes>
  )
});

const CustomerRoutes = () => {
  return (
    <Routes>
      <Route path="/live/c/:slug" element={<CustomerCallView />} />
      <Route path="/customer/thanks" element={<CustomerThanksView />} />
      <Route path="/customer/review" element={<CustomerReviewView />} />
      <Route path="/customer/login/:slug/:pin" element={<CustomerLogin />} />
    </Routes>
  )
}

function App() {

  return (
    <BrowserRouter>
      <ModalAlertProvider>
        <SelffixLoadingProvider>
          <Routes>
            <Route path="/" element={<div style={{
              display: 'flex',
              justifyContent: 'center', alignItems: 'center',
              width: '100vw',
              height: '100vh'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>

                <button className="button-cta-secondary" onClick={() => {
                  window.location.href = '/tech/login';
                }}><span>Tech Login</span></button>

              </div>
            </div>} />
          </Routes>


          {/* Routes */}
          <TechRoutes />
          <CustomerRoutes />

          {/* Modals */}
          <ModalAlert />
          <PleaseWait />
          <TextModalAlert />
          <RateOurServiceAlert />
          <ImageModal />
          <ScreenShotView />
          <SelffixLoading />
        </SelffixLoadingProvider>
      </ModalAlertProvider>
    </BrowserRouter>
  );
}

export default App;